export const UPDATE_RESTORATION_STATE = 'UPDATE_RESTORATION_STATE' as const;
export const CLEAR_RESTORATION_STATE = 'CLEAR_RESTORATION_STATE' as const;
export const ADD_CLEANUP_ID = 'ADD_CLEANUP_ID' as const;

export const updateRestorationState = (restorationId: string, payload: unknown) => ({
  type: UPDATE_RESTORATION_STATE,
  meta: {
    id: restorationId,
  },
  payload,
});

export const clearRestorationState = () => ({
  type: CLEAR_RESTORATION_STATE,
});

export const addCleanUpId = (restorationId: string) => ({
  type: ADD_CLEANUP_ID,
  payload: {
    id: restorationId,
  },
});
